module.exports = __webpack_public_path__ + "img/icon_friends@2x.c479104d.png";